import { getParticipantList } from "api/participant_list";
import { APIListData } from "api/types";
import { AxiosError } from "axios";
import { Participant } from "models";
import { useState } from "react";
import { useQuery } from "react-query";
import { TParticipantFilter } from "types/TParticipantFilter";
import { TSearchParamsRequired } from "types/TSearchParams";

const useLoadParticipants = ({
  searchParams
}: {
  searchParams: TSearchParamsRequired<TParticipantFilter>;
}) => {
  const [count, setCount] = useState(0);

  const { isLoading, error, data, refetch } = useQuery<APIListData<Participant>, AxiosError>({
    queryKey: [
      "participant_list",
      searchParams.page,
      searchParams.page_size,
      searchParams.search,
      searchParams.filter,
      searchParams.ordering
    ],
    queryFn: () =>
      getParticipantList({
        page: searchParams.page,
        size: searchParams.page_size,
        search: searchParams.search,
        filter: searchParams.filter,
        ordering: searchParams.ordering
      }),
    retry: (failureCount, error) => {
      if (error.response?.status === 404) {
        return false;
      }
      return failureCount < 3;
    },
    refetchOnWindowFocus: false,
    onSuccess: ({ data }) => {
      if (data.count !== count) setCount(data.count);
    }
  });

  return {
    isLoading,
    error,
    participants: data?.data?.results || ([] as Participant[]),
    refetch,
    count
  };
};

export default useLoadParticipants;
